// extracted by mini-css-extract-plugin
module.exports = {"section":"GeneralStatisticsCard_section__1S6jJ","icon":"GeneralStatisticsCard_icon__2It0x"};